import React, {useContext} from "react";
import {Fade} from "react-reveal";
import emoji from "react-easy-emoji";
import "./Greeting.scss";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import {greeting} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";
import ManOnTable from "../../assets/svg/ManOnTable";

export default function Greeting() {
  const {isDark} = useContext(StyleContext);
  
  if (!greeting.displayGreeting) {
    return null;
  }

  return (
    <Fade bottom duration={2000} distance="40px">
      <div className="main" id="greeting">
        <div className="component-main">
          <div>
            <h1
                className={isDark ? "dark-mode greeting-text" : "greeting-text"}
              >
                Hi, I'm<br/>
                {greeting.title}{" "}
                <span className="wave-emoji">{emoji(isDark?"👋🏻": "👋🏼")}</span>
            </h1>
            <p
                className={
                  isDark
                    ? "dark-mode greeting-text-p"
                    : "greeting-text-p subTitle"
                }
              >
                {greeting.subTitle}
            </p>
            <SocialMedia />
            <div className="button-greeting-div">
                <Button text="Contact me" href="#contact" className={"button1-margin"} />
                {greeting.resumeLink && (
                  <Button
                    text="See my resume"
                    className={"button2-margin"}
                    newTab={true}
                    href={greeting.resumeLink}
                  />
                )}
            </div>
          </div>
          <div className="component-image-div">
              <ManOnTable />
          </div>
        </div>
      </div>
    </Fade>
  );
}
